import CreateAttachmentResponse from 'owa-service/lib/contract/CreateAttachmentResponse';
import { ClientItemId } from 'owa-client-ids';
import createReferenceAttachmentFromAttachmentDataProviderOperation from 'owa-service/lib/operation/createReferenceAttachmentFromAttachmentDataProviderOperation';
import { CloudFile } from 'owa-attachment-file-types';
import { getDefaultRequestOptions } from 'owa-headers';

export default async function createReferenceAttachmentFromAttachmentDataProvider(
    parentItemId: ClientItemId,
    cancellationId: string,
    backingObject: CloudFile
): Promise<CreateAttachmentResponse> {
    const requestOptions = (await getDefaultRequestOptions(parentItemId.mailboxInfo)) || {};
    return await createReferenceAttachmentFromAttachmentDataProviderOperation(
        {
            itemId: parentItemId,
            attachmentDataProviderId: backingObject.providerId,
            location: backingObject.location,
            attachmentId: backingObject.fileId || '',
            dataProviderParentItemId: backingObject.fileParentId || '',
            providerEndpointUrl: backingObject.providerEndpointUrl,
            cancellationId: cancellationId,
            thumbnailUrl: backingObject.thumbnailUrl,
            previewUrl: backingObject.previewUrl,
            isFolder: backingObject.isFolder,
            mimeType: backingObject.type,
        },
        requestOptions
    );
}
